import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const TableAndSummaryTooltip = ({
  title,
  valueDisplay,
  sampleSizeDisplay,
  numeratorDisplay,
}: {
  title: string;
  valueDisplay: React.ReactNode;
  sampleSizeDisplay: React.ReactNode;
  numeratorDisplay: React.ReactNode;
}) => {
  const language = useLanguage();
  return (
    <>
      <div className="flex justify-between items-start mb-3">
        <h3 className="font-bold text-gray-900">{title}</h3>
      </div>
      <div>
        <div className="space-y-1">
          <p>
            <strong>{language.tableCellValueLabel()}</strong> {valueDisplay}
          </p>
          {numeratorDisplay && (
            <p>
              <strong>{language.tableCellCountLabel()}</strong>{' '}
              {numeratorDisplay}
            </p>
          )}
          <p>
            <strong>{language.tableCellSampleSizeLabel()}</strong>{' '}
            {sampleSizeDisplay}
          </p>
        </div>
      </div>
    </>
  );
};
